// extracted by css-extract-rspack-plugin
export default {"field":"FHlX9t","frequencyField":"G1NlGL"};